var React = require('react');

function Reset (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"x","transform":"translate(1.035 4.178)"},[React.createElement("circle",{"id":"Ellipse_9","data-name":"Ellipse 9","cx":"20","cy":"20","r":"20","transform":"translate(-1.035 -4.178)","fill":"#00a3e0","key":0}),React.createElement("g",{"id":"X-2","data-name":"X","transform":"translate(11.531 8.389)","key":1},[React.createElement("line",{"id":"Line_21","data-name":"Line 21","x1":"14","y2":"14","transform":"translate(0.433 0.433)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_52","data-name":"Path 52","d":"M0,0,14.867,14.867","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"2","key":1})])]));
}

Reset.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Reset;

Reset.default = Reset;
